/* Credit Hold
 * When window.creditHold === true:
 *   - Shows a persistent red banner at the top of the page
 *   - Blocks all add-to-cart attempts (fetch + form)
 *   - Disables checkout buttons on cart drawer and cart page
 */
(() => {
  'use strict';
  if (!window.creditHold) return;

  // ---- Banner ---------------------------------------------------------------
  const BANNER_ID = 'credit-hold-banner';

  function injectBanner() {
    if (document.getElementById(BANNER_ID)) return;

    const style = document.createElement('style');
    style.textContent = `
      #${BANNER_ID} {
        position: sticky;
        top: 0;
        left: 0;
        width: 100%;
        background: #c62828;
        color: #fff;
        text-align: center;
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.01em;
        z-index: 99999;
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      }
      #${BANNER_ID} a {
        color: #fff;
        text-decoration: underline;
      }
    `;
    document.head.appendChild(style);

    const banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.setAttribute('role', 'alert');
    banner.textContent = 'Your account has a current hold. Please contact customer service before placing an order.';

    // Insert as first child of body so it sits above everything
    document.body.insertBefore(banner, document.body.firstChild);
  }

  // ---- Block message --------------------------------------------------------
  function showBlockMessage() {
    let msg = document.getElementById('credit-hold-block-msg');
    if (msg) { msg.style.opacity = '1'; return; }

    msg = document.createElement('div');
    msg.id = 'credit-hold-block-msg';
    msg.setAttribute('role', 'alert');
    msg.style.cssText = `
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      background: #c62828;
      color: #fff;
      padding: 12px 24px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 600;
      z-index: 99999;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      transition: opacity .3s ease;
    `;
    msg.textContent = 'Your account is on hold. Please contact customer service.';
    document.body.appendChild(msg);

    setTimeout(() => { msg.style.opacity = '0'; }, 4000);
    setTimeout(() => { if (msg.parentElement) msg.remove(); }, 4400);
  }

  // ---- Block add-to-cart fetch ----------------------------------------------
  const _fetch = window.fetch;
  window.fetch = function(input, init = {}) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    const method = (init?.method || 'GET').toUpperCase();
    if (/\/cart\/add(\.js)?$/.test(url) && method === 'POST') {
      showBlockMessage();
      return Promise.reject(new Error('Account on credit hold.'));
    }
    return _fetch.apply(this, arguments);
  };

  // ---- Block add-to-cart form submit ----------------------------------------
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.action && /\/cart\/add/.test(form.action)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showBlockMessage();
    }
  }, true);

  // ---- Disable checkout buttons ---------------------------------------------
  const CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'button[name="checkout"]',
    '.cart__checkout-button',
    '#checkout',
    'input[name="checkout"]',
    '[data-checkout-button]',
  ].join(', ');

  function disableCheckoutButtons() {
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('title', 'Account on hold — contact customer service');
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.style.pointerEvents = 'none';
    });
  }

  // ---- Init -----------------------------------------------------------------
  function init() {
    injectBanner();
    disableCheckoutButtons();

    // Re-run on cart drawer open / DOM changes (drawer injects buttons dynamically)
    const observer = new MutationObserver(disableCheckoutButtons);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
